import React, { FC, memo } from 'react';
import clsx from 'clsx';
import { cva } from 'class-variance-authority';
import { Tab } from '../Tab';

const TabGroupCVA = cva(['flex', 'flex-row'], {
  variants: {
    variant: {
      filled: '',
    },
    appearance: {
      pill: 'rounded-[--corner-full]',
    },
  },
  compoundVariants: [
    {
      variant: 'filled',
      appearance: 'pill',
      className: 'gap-0 p-[--padding-zero] border-2 border-[--tab-border-selected-filled]',
    },
  ],
});

export interface TabItem {
  label: string;
  id: string;
}

export interface TabGroupProps {
  variant?: 'filled'; // ! only filled is supported
  appearance?: 'pill'; // ! only pill is supported
  className?: string;

  tabs: TabItem[];

  selectedId: string;
  onChangeTab?: (tabId: string) => void;
}

const BaseTabGroup: FC<TabGroupProps> = ({
  variant = 'filled',
  appearance = 'pill',
  className,
  onChangeTab,
  selectedId,
  tabs,
}) => {
  return (
    <div className={clsx('flex w-full md:w-fit', className)}>
      <div className={clsx(TabGroupCVA({ variant, appearance }), 'w-full')}>
        {tabs.map(tab => {
          const onClick = () => {
            onChangeTab?.(tab.id);
          };

          return (
            <Tab
              key={tab.id}
              onClick={onClick}
              selected={selectedId === tab.id}
              variant={variant}
              appearance={appearance}
              borderWidth="zero"
              className="flex-1"
            >
              {tab.label}
            </Tab>
          );
        })}
      </div>
    </div>
  );
};

export const TabGroup = memo(BaseTabGroup);
